/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const createMainLayoutStyles = makeStyles<Theme, { drawerWidth: number }>((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      background: '#FFFFFF',
      wordBreak: 'break-word',
    },
    drawerHeader: {
      display: 'flex',
      flex: '0 0 76px',
      alignItems: 'center',
      padding: '0 8px',
      minHeight: '76px',
      justifyContent: 'flex-end',
    },
    content: {
      display: 'flex',
      // overflow: "hidden",
      flexDirection: 'column',
      flexGrow: 1,
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: ({ drawerWidth }) => -drawerWidth,
      minHeight: '100vh',
    },
    contentBox: {
      flex: 1,
      padding: '20px 20px',
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: '0 !important',
    },
  }),
);

export { createMainLayoutStyles };
